import { UserType } from '@texas/api/endpoints/userApi';
import { userTypeFriendlyName } from '@texas/utils/helpers/roleHelpers';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const standardRoles = [
  UserType.ProductDeveloper,
  UserType.BrandCoordinator,
  UserType.KeyAccountManager,
  UserType.CustomerService,
];

export interface CustomerRoleFilterProps {
  value?: UserType | null;
  onChange: (value?: UserType | null) => void;
}

export function useCustomerRoleFilter({
  value,
  onChange,
}: CustomerRoleFilterProps) {
  const { t } = useTranslation();

  const options = useMemo(
    () => [
      ...standardRoles.map((role) => ({
        label: userTypeFriendlyName(role, t),
        value: role,
      })),
      { label: t('customerUser.other'), value: 'other' as const },
    ],
    [t],
  );

  const onSelectedValueChange = (selectedValue: UserType | 'other' | null) => {
    onChange(selectedValue === 'other' ? null : selectedValue ?? undefined);
  };

  return {
    options,
    selectedValue: value === null ? ('other' as const) : value,
    onSelectedValueChange,
  };
}
